/* ============================================================
   Mybibblio — sticky mobile add-to-cart bar
   Pure UI: shows a fixed bottom bar on phones once the real
   buy button scrolls out of view. Its button simply clicks the
   real add-to-cart button, so ALL existing behaviour (required
   fields, photo upload block, add-on bundling) runs unchanged.
   ============================================================ */
(function () {
  function init() {
    var bar = document.querySelector('[data-kb-satc]');
    if (!bar || bar.dataset.kbInit === '1') return;
    var realBtn = document.querySelector('product-form-component button[name="add"], button[name="add"], .add-to-cart-button');
    if (!realBtn) return;
    bar.dataset.kbInit = '1';

    var btn = bar.querySelector('[data-kb-satc-btn]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        realBtn.click();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        // show only after the real button has scrolled up out of view
        var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', passed);
      }, { threshold: 0 });
      io.observe(realBtn);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
